import { AnyPromotionInfo, DataResponse } from '../models';
import { ceV2Axios } from './axios';

export const getActivePromotion = async (): Promise<AnyPromotionInfo | null> => (
  await ceV2Axios.get<DataResponse<AnyPromotionInfo | null>>('/promotion/active', {
    headers: {
      'Content-Type': 'application/json',
      'Cache-Control': 'no-cache',
    },
  })
).data.data;

export const checkStarterPackage = async (
  { accountId, spEnabled }: { accountId: number, spEnabled: boolean },
) => (
  await ceV2Axios.get<DataResponse<boolean>>(`/promotion/starter-package/${accountId}/check`, {
    headers: {
      'Content-Type': 'application/json',
      'Cache-Control': 'no-cache',
    },
    params: {
      spEnabled,
    },
    data: {},
  })
).data.data;

export const checkFirstThreeLicenses = async () => (
  await ceV2Axios.get<DataResponse<boolean>>('/promotion/first-three-licenses/check', {
    headers: {
      'Content-Type': 'application/json',
      'Cache-Control': 'no-cache',
    },
    params: {},
    data: {},
  })
).data.data;
